import React from 'react';

const monthLabel = (ym) => {
  const [y, m] = ym.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('en-US', { month: 'short', year: '2-digit' });
};

export const PortfolioChart = ({ points }) => {
  if (!points || points.length < 2) return null;
  const vals = points.map((p) => p.value);
  const min = Math.min(...vals);
  const max = Math.max(...vals);
  const range = max - min || 1;
  const w = 720;
  const h = 200;
  const step = w / (points.length - 1);
  const coords = points.map((p, i) => [i * step, h - ((p.value - min) / range) * (h - 40) - 20]);
  const line = coords.map((c, i) => `${i === 0 ? 'M' : 'L'}${c[0].toFixed(1)},${c[1].toFixed(1)}`).join(' ');
  const area = `${line} L${w},${h} L0,${h} Z`;
  const mid = points[Math.floor(points.length / 2)];
  return (
    <div data-testid="portfolio-chart">
      <svg viewBox={`0 0 ${w} ${h}`} className="h-48 w-full" preserveAspectRatio="none">
        <defs>
          <linearGradient id="pfg" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#8BC53F" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#8BC53F" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path d={area} fill="url(#pfg)" />
        <path d={line} fill="none" stroke="#F4BE1B" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
        <circle cx={coords[coords.length - 1][0]} cy={coords[coords.length - 1][1]} r="4" fill="#F4BE1B" />
      </svg>
      <div className="mt-2 flex items-center justify-between text-[11px] uppercase tracking-wider text-farmway-cream/40">
        <span>{monthLabel(points[0].date)}</span>
        <span>{monthLabel(mid.date)}</span>
        <span>{monthLabel(points[points.length - 1].date)}</span>
      </div>
    </div>
  );
};

export default PortfolioChart;
